import { render, staticRenderFns } from "./purchaseBalanceDetails.vue?vue&type=template&id=559937bf&scoped=true"
import script from "./purchaseBalanceDetails.vue?vue&type=script&lang=js"
export * from "./purchaseBalanceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559937bf",
  null
  
)

export default component.exports